import { Button, Card, Col, Divider, Flex, Modal, Row, Select, Space } from 'antd';
import BlocksEditor from './block/Editor';

const HomePageDesktop = ({ viewModel }) => {
    const {
        blocks,
        display,
        showAdd,
        pageUrl,
        displayOptions,
        addBlockOptions,
        setDisplay,
        setShowAdd,
        onSave,
        onBlocksChange,
        onAddBlock,
    } = viewModel;

    return (
        <>
            <Space direction='vertical' style={{ width: '100%' }}>
                <Card title='Thiết kế'>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Card title='Xem trước' size='small'>
                                <Flex justify='center'>
                                    <iframe src={pageUrl} style={{ height: 700, width: 450, border: 'none', scrollbarWidth: 0 }} id='previewIfame' />
                                </Flex>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Card title='Mẫu trang chủ' size='small'>
                                <Select value={display} onChange={setDisplay} options={displayOptions} style={{ width: 300 }} />
                            </Card>
                            {display === 'custom' && (
                                <>
                                    <Divider>Thiết kế</Divider>
                                    <BlocksEditor data={blocks} onChange={onBlocksChange} />
                                </>
                            )}
                            <Divider />
                            <Flex justify='flex-end'>
                                <Space>
                                    {display === 'custom' && (
                                        <Button type='primary' onClick={() => setShowAdd(true)}>
                                            Thêm Block
                                        </Button>
                                    )}
                                    <Button type='primary' onClick={onSave}>
                                        Lưu
                                    </Button>
                                </Space>
                            </Flex>
                        </Col>
                    </Row>
                </Card>
            </Space>

            <Modal open={showAdd} title='Thêm block' footer={null} onCancel={() => setShowAdd(false)}>
                <Row gutter={[8, 8]}>
                    {addBlockOptions.map((item) => (
                        <Col span={12} key={item.key}>
                            <Card
                                style={{ width: '100%' }}
                                actions={[
                                    <Button key='add' onClick={() => onAddBlock(item.key)} type='primary'>
                                        Thêm
                                    </Button>,
                                ]}
                            >
                                <Card.Meta title={item.title} description={item.description} />
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Modal>
        </>
    );
};

export default HomePageDesktop;
